import { SxProps } from '@mui/material';

export const ContainerSx: SxProps = {
  display: 'flex',
  flexDirection: 'row',
  gap: 2,
  flexWrap: 'wrap',
  width: '100%',
  alignItems: 'flex-start'
}; 
